import { redirect, type LoaderFunctionArgs } from "react-router";
import { login } from "../shopify.server";

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }
  return await login(request);
}

export default function Index() {
  return (
    <main style={{ fontFamily: "system-ui", padding: "2rem", maxWidth: 720 }}>
      <h1>Supnex: AI Support Automation</h1>
      <p>This app is installed directly from the Shopify App Store or Partner Dashboard.</p>
    </main>
  );
}
